import { isRejectedWithValue } from '@reduxjs/toolkit'
import { Middleware } from '@reduxjs/toolkit'
import { addErrorRTKToast } from 'src/utils/helpers'

export const rtkQueryErrorMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // these are the same values we check for in useSignedUrl, we don't want to show a rejected state every time these expiries happen, we silently refetch the background
    const skip =
      action?.payload?.error === 'AccessDenied' ||
      action?.payload?.error === 'ExpiredToken'
    if (!skip) {
      const message = action?.payload?.data?.message || action?.error?.message
      addErrorRTKToast(message)
    }
  }

  return next(action)
}
